export default __webpack_public_path__ + "static/media/playstore.382dd66d.svg";